import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.search', {
      wrapper: {
        display: 'flex',
        position: 'relative',
      },
    }),
  ]
}
